export enum EWordType {
  SarWord = 1,
  RSWord = 2,
  GuessWord = 3,
  BreadcrumbsWord = 4,
}

export interface SearchWord {
  word: string;
  wordType: EWordType;
}

export interface IGuessWordCard {
  words: SearchWord[];
  pos: number;
}

export type IGuessWordCards = IGuessWordCard[];
